var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":!!(_vm.isDark === 'dark')}},[(this.$router.currentRoute.name != 'Login' &&
           this.$router.currentRoute.name != 'Assinatura')?_c('Menu'):_vm._e(),_c('v-main',{attrs:{"dark":!!(_vm.isDark === 'dark')}},[_c('v-container',{staticClass:"pa-0"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }